import { createFileRoute } from '@tanstack/react-router'
import { WarehouseLocationsPage } from '@/features/warehouse/locations-page'

export const Route = createFileRoute('/_authenticated/warehouse/locations')({
  staticData: { title: 'Warehouse locations' },
  component: WarehouseLocationsPage,
})
